import { ICdItemLocation } from './ICdItemLocation';
import { ICDV3ViewItem } from '../../ui-toolkit/cdItems/interfaces/ICDViewItem';

export const createItemToLocation =
  (name: string, offset = 1) =>
  ({ id }: ICDV3ViewItem, index: number): ICdItemLocation => ({ id, line: index + offset, section: name });
